import React from "react";
import { useAuth } from "@/src/hooks/useAuth";
import { Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "@/src/layouts/admin";
import AuthLayout from "@/src/layouts/auth";

export function AuthProvider() {
  const { isAuthenticated } = useAuth();

  return (
    <Switch>
      {/* Auth routes */}
      <Route path="/auth">
        {isAuthenticated ? <Redirect to="/users" /> : <AuthLayout />}
      </Route>

      {/* Protected routes */}
      <Route exact path="/">
        {!isAuthenticated ? (
          <Redirect to="/auth/login" />
        ) : (
          <Redirect to="/users" />
        )}
      </Route>

      <Route path="/">
        {!isAuthenticated ? <Redirect to="/auth/login" /> : <AdminLayout />}
      </Route>

      {/* Catch-all route - will handle any undefined routes */}
      <Route path="*">
        {!isAuthenticated ? (
          <Redirect to="/auth/login" />
        ) : (
          <Redirect to="/users" />
        )}
      </Route>
    </Switch>
  );
}
